import React from "react";
import { Box, Typography } from "@mui/material";

const ProgressBar = ({ value, maxValue, isValueSales = false, showPercentage = false, type, }) => {
  const percentage = maxValue > 0 ? (value / maxValue) * 100 : 0;

  const formatValueSales = (val) => {
    if (typeof val === "number") {
      const inMillions = val / 1_000_000;
      return `${inMillions.toFixed(2)}`;
    }
    return val;
  };

  const getBarColor = () => {      
    if (type === "manufacturer") return "#74ccfc";     
    return "#b9dff4"; 
  };

  return (
    <Box sx={{ position: "relative", width: "100%", minWidth: 30 }}>
      {/* Background bar */}
      <Box
        sx={{
          width: "100%",
          height: { xs: 14, sm: 16, md: 20 },
          backgroundColor: "#f5f5f5",
          position: "relative",
          overflow: "hidden",
          borderRadius: "4px",
        }}
      >
        {/* Filled bar */}
        <Box
          sx={{
            width: `${percentage}%`,
            height: "100%",
            background: getBarColor(),
            transition: "width 0.3s ease-in-out",
          }}
        />
      </Box>
      {/* Value text */}
      <Typography
        variant="body2"
        fontWeight={550} 
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: "black",
          fontSize: { xs: 10, sm: 11, md: 12 },
          zIndex: 1,
          whiteSpace: "nowrap",
        }}
      >
        {isValueSales ? formatValueSales(value) : value.toLocaleString()}
        {showPercentage && "%"}
      </Typography>
    </Box>
  );
};

export default ProgressBar;
